export default __webpack_public_path__ + "static/favicon-4bbf4f4a489b054f84ed44418c3f1937.ico";